import * as React from 'react';
import { Route, Switch } from 'react-router';
import { FDIDashboard, MCILDashboard } from './Dashboard';

const Home = () => <h1>Business Intelligence (BI) Software &amp; Analytics Tools | Data Focus</h1>;

export default class extends React.Component {
  render() {
    return (
      <div className="App">
        <Switch>
          <Route exact={true} path="/" component={Home} />
          <Route path="/fdi/:stateName" component={FDIDashboard} />
          <Route path="/fdi/" component={FDIDashboard} />
          <Route path="/mcil/:stateName" component={MCILDashboard} />
          <Route path="/mcil/" component={MCILDashboard} />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root.tsx